export default __webpack_public_path__ + "static/media/create_draft.cf684f50.svg";